export class FiltroBuscaInstituicoes {

    codigoMunicipio?: number;
    areaParticipacao?: number;
    nomeInstituicao: string;

    constructor(codigoMunicipio?: number, areaParticipacao? : number, nomeInstituicao? : string) {
        this.codigoMunicipio = codigoMunicipio;
        this.areaParticipacao = areaParticipacao;
        this.nomeInstituicao = nomeInstituicao;
    }
}



// WEBPACK FOOTER //
// ./src/app/restrito/instituicao/shared/filtro-busca-instituicoes.ts